import type { PayloadAction } from '@reduxjs/toolkit';
import { t } from 'i18next';
import {
	call,
	put,
	takeLatest
} from 'redux-saga/effects';
import {
	addSecondsToCurrentDate,
	removeAuth0VaporCookie,
	setAuth0VaporCookie
} from 'vio-libs';

import { IAuth0ActionPayload } from '../../interfaces';

import { postLogin, postLogout } from './data';
import {
	errorReceiveRemoveServerSideCookie,
	errorReceiveSetServerSideCookie,
	failedReceiveRemoveServerSideCookie,
	failedReceiveSetServerSideCookie,
	receiveRemoveServerSideCookie,
	receiveSetServerSideCookie
} from './slice';

export function* requestRemoveServerSideCookie() {
	try {
		const response = yield call(postLogout);

		if (!response || response.status !== 204) {
			yield put(errorReceiveRemoveServerSideCookie());
		}
		else {
			yield put(receiveRemoveServerSideCookie());
		}
	}
	catch (e) {
		yield put(failedReceiveRemoveServerSideCookie());
	}

	// we want to remove the client cookie even if the logout request fails
	removeAuth0VaporCookie();
}

export function* requestSetServerSideCookie(action: PayloadAction<IAuth0ActionPayload>) {
	try {
		const { auth0Authentication } = action.payload;

		if (auth0Authentication !== undefined) {
			const {
				accessToken,
				expiresIn,
				idToken,
				state,
				tokenType
			} = auth0Authentication;
			const response = yield call(postLogin, idToken);

			if (!response || response.status !== 204) {
				yield put(errorReceiveSetServerSideCookie());
			}
			else {
				setAuth0VaporCookie({
					accessToken,
					expiresInDate: addSecondsToCurrentDate(expiresIn),
					idToken,
					state,
					tokenType
				});
				yield put(receiveSetServerSideCookie());
			}
		}
		else {
			throw new Error(t('NO_AUTH0_AUTHENTICATION_AVAILABLE', { ns: 'Common' }));
		}
	}
	catch (e) {
		yield put(failedReceiveSetServerSideCookie());
	}
}

export function* watchRequestRemoveServerSideCookie() {
	yield takeLatest('auth/requestRemoveServerSideCookie', requestRemoveServerSideCookie);
}

export function* watchRequestSetServerSideCookie() {
	yield takeLatest('auth/requestSetServerSideCookie', requestSetServerSideCookie);
}
